import { type InjectionKey } from 'vue';

export const FORM_ITEM_INJECTION_KEY =
  Symbol('FORM_ITEM_INJECTION_KEY') as InjectionKey<string>;
